
<div class="dashboard-content-sec">
    <div class="card mb-0">
        <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>
        <div class="user-heading-sec">
            <div class="mr-4 d-inline-block">
                <span class="p-2" href="#">
                        {{this.total}} State Updates</span>
            </div>
 
            <div style='width: 140px' class="d-inline-block">
                <a  href="javascript:void(0)" [routerLink]="['/admins/states']" 
                    class="btn btn-default fa fa-user-circle">
                    Add State Update
                </a>     
            </div>  
          
        </div>

        <div id="stateUpdateTable" class="table-responsive">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table table-striped" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i> {{header.text}}
                        </th>
                      <th>Delete</th>
                    </tr>
                    <tr>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByState($event)"/>
                            </div>
                        </th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let state of states">
                        <tr>
                        
                            <td >
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/states',state.ID]">
                                    {{state.State}}
                                </a>
                            </td>

                            <td >
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/states',state.ID]">
                                    {{state.LongName}}
                                </a>
                            </td>

                          
                            <td>
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/states',state.ID]">
                                    {{state.NewUpdates }}
                                </a>
                            </td>

                            <td>
                                <div class="d-inline-block">
                                    <a title="Delete" class="btn fa fa-times" (click)="deleteStates(state.ID)"> </a>
                                </div>
                            </td>
                        </tr>

                    </ng-container>
                </tbody>

                <ng-container *ngIf="states?.length == 0">
                  <tr><td colspan="5">No Result Found</td></tr>
                </ng-container>



            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
